import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import './book.css';

const BookAppointmentButton = () => {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    parent_name: '',
    child_name: '',
    child_age: '',
    email: '',
    phone: '',
    date: '',
    concerns_questions: '',
    service: '' // Added service field
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      console.log('Submitting formData:', formData);

      const response = await fetch('https://api.deepticentre.com/deeptischool/add/schedule-visit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const result = await response.json();
      console.log('API response:', result);

      if (response.ok) {
        alert('Appointment scheduled successfully!');
        setShow(false);
        setFormData({
          parent_name: '',
          child_name: '',
          child_age: '',
          email: '',
          phone: '',
          date: '',
          concerns_questions: '',
          service: '' // Reset service as well
        });
      } else {
        alert(`Failed to schedule appointment: ${result.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error occurred while scheduling:', error);
      alert('An error occurred while scheduling the appointment.');
    }
  };

  return (
    <>
      <button className="book-appointment-button" onClick={() => setShow(true)}>
        Book an Appointment
      </button>

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Book Appointment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Parent Name</Form.Label>
              <Form.Control
                type="text"
                name="parent_name"
                value={formData.parent_name}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Child Name</Form.Label>
              <Form.Control
                type="text"
                name="child_name"
                value={formData.child_name}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Child Age</Form.Label>
              <Form.Control
                type="number"
                name="child_age"
                value={formData.child_age}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Services Dropdown */}
            <Form.Group>
              <Form.Label>Select a Service</Form.Label>
              <Form.Select
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
              >
                <option value="">-- Select a Service --</option>
                <option value="Physiotherapy">Physiotherapy</option>
                <option value="Speech and Language Therapy">Speech and Language Therapy</option>
                <option value="Occupational Therapy">Occupational Therapy</option>
                <option value="Developmental Therapy">Developmental Therapy</option>
                <option value="Hydrotherapy">Hydrotherapy</option>
                <option value="Behavioral Therapy">Behavioral Therapy</option>
                <option value="Yoga Therapy">Yoga Therapy</option>
                <option value="Horticultural Therapy">Horticultural Therapy</option>
              </Form.Select>
            </Form.Group>

            <Form.Group>
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Concerns / Questions</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="concerns_questions"
                value={formData.concerns_questions}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BookAppointmentButton;
